<div class="minor-account-accept">
  @if (!ready) {
    <div>
      <se-fe-spinner
        [seFeDataSize]="900"
        [seFeDataInverted]="false"
        [seFeDataCenter]="true"
      ></se-fe-spinner>
    </div>
  }
  @if (ready) {
    <div class="minor-account-accept-icon">
      <se-fe-icon
        seFeDataName="spot_copy"
        seFeDataSize="950"
        seFeDataAriaLabel="copy"
        [seFeDataMargin]="false"
      ></se-fe-icon>
    </div>
    <div class="minor-account-accept-title">
      <se-po-highlight-label
        label="Account transfer"
      ></se-po-highlight-label>
      <div class="minor-account-accept-subtitle">Transferring to @if (!existingAccount) {
        new
      }parent account: {{ emailAddress }}</div>
    </div>
    <div>
      <form [formGroup]="form" (submit)="onSubmit()" method="get" [action]="actionUrl">
        <input formControlName="token" type="hidden" name="token">
        @if (existingAccount) {
          <p>
            Great, since you already have an account we'll transfer all of the information and activity from
            {{ fromName }}'s account to yours after you sign in. This includes previous registrations, teams, memberships, etc.
            <span>Learn more</span>
          </p>
          <p>Thanks for helping keep sports a safe and secure place for kids!</p>
          <div class="form-submit">
            <se-fe-button
              seFeDataEmphasis="high"
              seFeDataType="submit"
            [seFeDataFullWidth]="true">Continue</se-fe-button>
          </div>
        }
        @if (!existingAccount) {
          <p>
            We didn't find an account with that email.
            Let's set a new one up for you as the parent and we'll transfer all of the previous information and activity from
            {{ fromName }}'s account to yours. This includes previous registrations, teams, memberships, etc.
            <span>Learn more</span>
          </p>
          <p>Thanks for helping keep sports a safe and secure place for kids!</p>
          <div class="form-submit">
            <se-fe-button
              seFeDataEmphasis="high"
              seFeDataType="submit"
            [seFeDataFullWidth]="true">Let's Go!</se-fe-button>
          </div>
        }
      </form>
    </div>
  }
</div>
